(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["do3d-marketplace"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('d3-banner-carousel')) {
  let library;
  customElements.define('d3-banner-carousel', class extends HTMLElement {
    async connectedCallback() {
      if (this.initializing) return;
      this.initializing = true;
      this.events = new AbortController();
      const launch = this.querySelector('[data-launch-slide]');
      if (launch && Date.now() >= Date.parse(launch.dataset.ends)) {
        launch.remove();
        this.querySelector('[data-launch-dot]')?.remove();
      }
      this.slides = [...this.querySelectorAll('[data-d3-slide]')];
      this.dots = [...this.querySelectorAll('[data-d3-go]')];
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduced.matches;
      try {
        library ||= import('https://cdn.jsdelivr.net/npm/swiper@12.0.3/swiper-bundle.min.mjs');
        const { default: Swiper } = await library;
        if (!this.isConnected) return;
        this.slides.forEach(slide => {
          slide.hidden = false;
          slide.querySelectorAll('a,img').forEach(item => item.draggable = false);
        });
        this.slider = new Swiper(this.querySelector('.d3-banner-viewport'), {
          wrapperClass: 'd3-banner-slides',
          slideClass: 'd3-carousel-slide',
          slidesPerView: 1,
          loop: true,
          speed: this.reduced.matches ? 0 : 420,
          threshold: 5,
          longSwipesRatio: 0.12,
          longSwipesMs: 250,
          grabCursor: true,
          touchStartPreventDefault: false,
          preventClicks: true,
          preventClicksPropagation: true,
          autoplay: { delay: 4000, disableOnInteraction: false, pauseOnMouseEnter: false },
          navigation: { prevEl: this.querySelector('[data-d3-prev]'), nextEl: this.querySelector('[data-d3-next]') },
          a11y: { enabled: true, prevSlideMessage: this.querySelector('[data-d3-prev]').ariaLabel, nextSlideMessage: this.querySelector('[data-d3-next]').ariaLabel },
          on: {
            init: swiper => this.sync(swiper),
            realIndexChange: swiper => this.sync(swiper),
            autoplayTimeLeft: (swiper, time, remaining) => this.style.setProperty('--d3-progress', String(1 - remaining))
          }
        });
        this.dataset.ready = 'true';
        this.dataset.engine = 'swiper-12.0.3';
        this.querySelector('.d3-banner-controls').hidden = false;
        const options = { signal: this.events.signal };
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.slider.slideToLoop(i), options));
        this.querySelector('[data-d3-pause]').addEventListener('click', () => {
          this.paused = !this.paused;
          this.updatePlayback();
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          event.key === 'ArrowLeft' ? this.slider.slidePrev() : this.slider.slideNext();
        }, options);
        this.addEventListener('focusin', event => {
          if (event.target.matches(':focus-visible') && event.target.closest('.d3-banner-viewport')) this.slider.autoplay.stop();
        }, options);
        this.addEventListener('focusout', () => queueMicrotask(() => {
          if (!this.querySelector('.d3-banner-viewport').contains(document.activeElement)) this.updatePlayback();
        }), options);
        this.reduced.addEventListener('change', () => {
          this.paused = this.reduced.matches;
          this.slider.params.speed = this.paused ? 0 : 420;
          this.updatePlayback();
        }, options);
        this.updatePlayback();
        if (launch?.isConnected) this.expiry = setTimeout(() => {
          this.slider.destroy(true, true);
          this.events.abort();
          launch.remove();
          this.querySelector('[data-launch-dot]')?.remove();
          this.initializing = false;
          this.connectedCallback();
        }, Math.min(2147483647, Math.max(0, Date.parse(launch.dataset.ends) - Date.now())));
      } catch (error) {
        this.dataset.engine = 'fallback';
        this.slides.forEach(slide => { slide.hidden = false; });
      }
    }
    sync(swiper) {
      this.dataset.active = String(swiper.realIndex);
      this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === swiper.realIndex)));
      this.slides.forEach((slide, i) => {
        slide.setAttribute('aria-hidden', String(i !== swiper.realIndex));
        slide.querySelectorAll('a,button').forEach(link => link.tabIndex = i === swiper.realIndex ? 0 : -1);
      });
    }
    updatePlayback() {
      if (!this.slider) return;
      this.paused ? this.slider.autoplay.stop() : this.slider.autoplay.start();
      this.dataset.paused = String(this.paused);
      this.querySelector('[data-d3-pause]').setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
    }
    disconnectedCallback() {
      this.events?.abort();
      this.slider?.destroy(true, true);
      clearTimeout(this.expiry);
      this.initializing = false;
    }
  });
}

if (!customElements.get('d3-news-carousel')) {
  customElements.define('d3-news-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.track = this.querySelector('.d3-news-preview__grid');
      this.previous = this.querySelector('[data-news-prev]');
      this.next = this.querySelector('[data-news-next]');
      this.controls = this.querySelector('.d3-news-preview__arrows');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.sync(), { ...options, passive: true });
      this.track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        this.drag = { id: event.pointerId, x: event.clientX, left: this.track.scrollLeft, moved: false };
      }, options);
      this.track.addEventListener('pointermove', event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const delta = event.clientX - this.drag.x;
        if (!this.drag.moved && Math.abs(delta) < 8) return;
        if (!this.drag.moved) {
          this.drag.moved = true;
          this.track.setPointerCapture(event.pointerId);
          this.track.classList.add('is-dragging');
        }
        event.preventDefault();
        this.track.scrollLeft = this.drag.left - delta;
      }, options);
      const finishDrag = () => {
        if (!this.drag) return;
        if (this.drag.moved) this.suppressClickUntil = performance.now() + 350;
        this.track.classList.remove('is-dragging');
        this.drag = null;
      };
      this.track.addEventListener('pointerup', finishDrag, options);
      this.track.addEventListener('pointercancel', finishDrag, options);
      this.track.addEventListener('lostpointercapture', finishDrag, options);
      this.track.addEventListener('dragstart', event => event.preventDefault(), options);
      this.track.addEventListener('click', event => {
        if (performance.now() < (this.suppressClickUntil || 0)) { event.preventDefault(); event.stopPropagation(); }
      }, { ...options, capture: true });

      this.track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') {
          this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: this.reduced.matches ? 'instant' : 'smooth' });
        } else this.move(event.key === 'ArrowLeft' ? -1 : 1);
      }, options);
      this.resize = new ResizeObserver(() => this.sync());
      this.resize.observe(this.track);
      this.sync();
    }
    move(direction) {
      const card = this.track.querySelector('.d3-news-preview__card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: this.reduced.matches ? 'instant' : 'smooth' });
    }
    sync() {
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.controls.hidden = maximum <= 2;
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= maximum - 2;
    }
    disconnectedCallback() {
      this.events?.abort();
      this.resize?.disconnect();
      this.events = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["do3d-navigation"]) return;
  try {
    
(function () {
  function initializeProductSearch() {
    document.querySelectorAll('[data-d3-predictive]').forEach(form => {
      if (form.dataset.searchReady) return;
      form.dataset.searchReady = '1';
      const input = form.querySelector('input[type="search"]');
      const panel = form.querySelector('.d3-search-results');
      const list = panel.querySelector('ul');
      const status = panel.querySelector('[role="status"]');
      const all = panel.querySelector('.d3-search-all');
      let timer, controller, sequence = 0, currentTerm = '', pointerInPanel = false;
      const close = () => { pointerInPanel = false; clearTimeout(timer); controller?.abort(); sequence++; panel.hidden = true; input.setAttribute('aria-expanded', 'false'); };
      const open = () => { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); };
      const formatPrice = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:form.dataset.currency || 'USD'}).format(Number(value));
      async function suggest(term) {
        if(!form.contains(document.activeElement)) return;
        const request = ++sequence;
        controller?.abort();
        controller = new AbortController();
        list.replaceChildren();
        status.textContent = form.dataset.loading;
        const resultURL = new URL(form.action);
        resultURL.searchParams.set('type','product');
        resultURL.searchParams.set('q',term);
        all.href = resultURL.href;
        open();
        try {
          const url = new URL(form.dataset.suggestUrl, location.origin);
          url.searchParams.set('q',term);
          url.searchParams.set('resources[type]','product');
          url.searchParams.set('resources[limit]','5');
          url.searchParams.set('resources[options][fields]','title,product_type,variants.title,vendor,tag,variants.sku');
          url.searchParams.set('resources[options][unavailable_products]','last');
          const response = await fetch(url,{signal:controller.signal,headers:{Accept:'application/json'}});
          if(!response.ok) throw Error('Search unavailable');
          const data = await response.json();
          if(request !== sequence || input.value.trim() !== term) return;
          const products = data.resources?.results?.products || [];
          products.forEach(product => {
            const destination = new URL(product.url, location.origin);
            if(destination.origin !== location.origin) return;
            const li = document.createElement('li');
            const link = document.createElement('a');
            link.className = 'd3-search-product';
            link.href = destination.href;
            const imageURL = product.featured_image?.url || product.image;
            if(imageURL){
              const image = document.createElement('img');
              image.src = imageURL;
              image.alt = '';
              image.width = 52;
              image.height = 58;
              link.append(image);
            }
            const copy = document.createElement('span');
            const title = document.createElement('strong');
            title.textContent = product.title;
            const price = document.createElement('small');
            price.textContent = product.type === 'Affiliate 3D Printer' || product.product_type === 'Affiliate 3D Printer' || product.vendor === 'Snapmaker' ? form.dataset.affiliateLabel : formatPrice(product.price);
            copy.append(title,price);
            link.append(copy);
            li.append(link);
            list.append(li);
          });
          status.textContent = list.children.length ? form.dataset.found : form.dataset.empty;
        } catch(error) {
          if(error.name === 'AbortError' || request !== sequence) return;
          status.textContent = form.dataset.failed;
        }
      }
      input.addEventListener('input',() => {
        clearTimeout(timer);
        controller?.abort();
        sequence++;
        close();
        const term = input.value.trim();
        currentTerm = term;
        if(term.length < 2) return;
        timer = setTimeout(()=>suggest(term),220);
      });
      input.addEventListener('focus',() => { const term=input.value.trim(); if(term.length>=2) suggest(term); });
      form.addEventListener('keydown',event => {
        pointerInPanel = false;
        if(event.key === 'Escape'){ input.focus(); close(); return; }
        if(panel.hidden || !['ArrowDown','ArrowUp'].includes(event.key)) return;
        const links = Array.from(panel.querySelectorAll('a'));
        const index = links.indexOf(document.activeElement);
        const next = event.key === 'ArrowDown' ? Math.min(index+1,links.length-1) : index-1;
        event.preventDefault();
        if(next < 0) input.focus(); else links[next]?.focus();
      });
      form.addEventListener('focusout',event => {
        if (form.contains(event.relatedTarget)) return;
        // Safari can blur the input without focusing a tapped link. Keep that
        // link rendered until its native click completes; do not hijack taps.
        if (!event.relatedTarget && pointerInPanel) return;
        close();
      });
      document.addEventListener('pointerdown',event => {
        pointerInPanel = !panel.hidden && panel.contains(event.target);
        if (!form.contains(event.target)) close();
      });
      document.addEventListener('pointercancel',() => { pointerInPanel = false; });
      document.addEventListener('focusin',event => { if (!form.contains(event.target)) close(); });
      form.addEventListener('submit',()=>{clearTimeout(timer);controller?.abort();close();});
      window.addEventListener('pageshow',()=>close());
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initializeProductSearch,{once:true}); else initializeProductSearch();
  document.addEventListener('shopify:section:load',initializeProductSearch);
})();



(function(){
  function showSellerShortcut(){
    const shortcut=document.querySelector('[data-d3-seller-shortcut]');
    if(shortcut)shortcut.hidden=!document.cookie.split(';').some(value=>value.trim()==='d3_seller_shortcut=1');
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',showSellerShortcut,{once:true});else showSellerShortcut();
  window.addEventListener('pageshow',showSellerShortcut);
  document.addEventListener('shopify:section:load',showSellerShortcut);
})();

(function () {
  function initializeAccountChoices() {
    const dialog = document.getElementById('D3AccountChoices');
    if (!dialog || dialog.dataset.ready || !dialog.showModal) return;
    dialog.dataset.ready = '1';
    const query = new URLSearchParams(location.search);
    const seller = query.get('do3d_next') === 'seller';
    dialog.querySelector('[data-d3-selling-fee]').hidden = !seller;
    const returnURL = new URL(location.href);
    returnURL.searchParams.delete('do3d_account');
    returnURL.searchParams.delete('do3d_next');
    const returnTo = seller ? '/?do3d_seller=1&do3d_auth=1' : returnURL.pathname + returnURL.search + returnURL.hash;
    dialog.querySelectorAll('[data-d3-account-continue]').forEach(function (link) {
      link.href = '/customer_authentication/login?return_to=' + encodeURIComponent(returnTo);
    });
    document.querySelectorAll('[data-d3-account-open]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button) return;
        event.preventDefault();
        dialog.showModal();
      });
    });
    dialog.querySelector('[data-d3-account-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) {
      const box = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
    });
    if (query.get('do3d_account') === '1') dialog.showModal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAccountChoices, {once:true});
  else initializeAccountChoices();
  document.addEventListener('shopify:section:load', initializeAccountChoices);
})();

if (!customElements.get('d3-sticky-header')) {
  customElements.define('d3-sticky-header', class extends HTMLElement {
    connectedCallback() {
      if (this.controller || !this.hasAttribute('enabled')) return;
      const group = this.closest('#header-group');
      if (!group) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.previousHeight = document.documentElement.style.getPropertyValue('--d3-header-height');
      const updateHeight = () => {
        document.documentElement.style.setProperty('--d3-header-height', group.getBoundingClientRect().height + 'px');
      };
      this.toggleAttribute('data-inspecting', Boolean(window.Shopify?.inspectMode));
      document.addEventListener('shopify:inspector:activate', () => {
        this.setAttribute('data-inspecting', '');
      }, options);
      document.addEventListener('shopify:inspector:deactivate', () => {
        this.removeAttribute('data-inspecting');
        updateHeight();
      }, options);
      this.resizeObserver = new ResizeObserver(updateHeight);
      this.resizeObserver.observe(group);
      updateHeight();
    }
    disconnectedCallback() {
      if (!this.controller) return;
      this.controller.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      if (this.previousHeight) {
        document.documentElement.style.setProperty('--d3-header-height', this.previousHeight);
      } else {
        document.documentElement.style.removeProperty('--d3-header-height');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
document.addEventListener('click',event=>{const button=event.target.closest('.d3-affiliate-thumb');if(!button)return;const gallery=button.closest('.d3-affiliate-gallery');const image=gallery.querySelector('.d3-affiliate-hero img');if(!image)return;image.removeAttribute('srcset');image.src=button.dataset.image;image.alt=button.dataset.alt;gallery.querySelectorAll('.d3-affiliate-thumb').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));});

  } catch(e) { console.error(e); }
})();
})();
